<template>
    <div>        
        <queryview ref="qlist" :qvtype="qvtype" :selectable="selectable" :hovericons="hovericons"
            :currentkey="currentkey" :extrafilter="extrafilter" :toolbar="toolbar" :navbar="navbar"
            :qvbuttons="qvbuttons" v-on:rowclicked="rowclicked" v-on:iconhover="iconhover" v-on:iconunhover="iconunhover"
            v-on:currentkeychanged="currentkeychanged" v-on:selectionchanged="selectionchanged">
        </queryview>
        <lmodal :title="title" v-model="detailsvisible" @ok="detailsvisible = false" :domain="qvtype" @close="onclose">
            <template v-slot:modal-title>
                <b-button-toolbar>
                    <!-- <h3>Fraktdetaljer</h3> -->
                    <h3>{{ title }}</h3>
                    &nbsp;
                    <b-button-group>
                        <b-button @click="StepCurrent(-1)" variant="outline" title="Föregående (Ctrl+Alt+Vänster)">
                            <b-icon-caret-left></b-icon-caret-left>
                        </b-button>
                        <b-button @click="StepCurrent(1)" variant="outline" title="Nästa (Ctrl+Alt+Höger)">
                            <b-icon-caret-right></b-icon-caret-right>
                        </b-button>
                        <slot name="actionbuttons"></slot>
                        <!-- <bookingactionbutton v-if="currId > 0" :ids="[currId]" v-on:actionready="OnActionReady">
              </bookingactionbutton> -->
                        <div class="input-group-append" v-if="isBusy">
                            <b-icon icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon>
                        </div>
                    </b-button-group>
                </b-button-toolbar>
            </template>
            <slot name="details"></slot>
        </lmodal>
    </div>
</template>
<script>
import lmodal from "@/components/l-modal.vue";

import queryview from "@/views/queryview/queryview";

export default {
    name: 'queryviewlistdetail',
    props: {
        //Should reflect all props in QueryView
        qvtype: {
            type: String,
            default: "",
        },
        selectable: Boolean,
        cmdcolumn: Boolean,
        currentkey: null,
        hovericons: { type: Array },
        extrafilter: null,
        toolbar: { type: Boolean, default: true },
        navbar: { type: Boolean, default: true },
        qvbuttons: { type: Boolean, default: true },
        isBusy: false,
        //details
        title: '',
        detailsvisible: false,
    },
    components: { queryview, lmodal },
    data() {
        return {
            myModal: false,
        }
    },
    watch: {
        value: function (e) {
            this.$emit('input', value);
        }
    },
    methods: {        
        rowclicked(row) {
            this.$emit('rowclicked', row);
        },
        iconhover(row) {
            this.$emit('iconhover', row);
        },
        iconunhover(row) {
            this.$emit('iconunhover', row);
        },
        currentkeychanged(row) {
            this.$emit('currentkeychanged', row);
        },
        selectionchanged(sel) {
            this.$emit('selectionchanged', sel);
        },
        onclose(e) {
            this.$emit('close',false);
        },
        //Expose 
        StepCurrent(s) {
            this.$refs.qlist.StepCurrent(s);
        },
        GetRowById(currId) {
            return this.$refs.qlist.GetRowById(currId);
        }
        
    }
}
</script>